import { toastError } from '@helpers/toastError'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const distanceLearningTimetable = createAsyncThunk(
  TYPES.DISTANCE_LEARNING_TIMETABLE,
  async (
    params: PayloadCreatorParams<`${typeof API.DISTANCE_LEARNING_TIMETABLE}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.distanceLearningTimetable(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

// export const timetableUpdated = createAsyncThunk(
//   TYPES.TIMETABLE_UPDATED,
//   async (params: PayloadCreatorParams<`${typeof API.TIMETABLE_UPDATED}`, 'get'> | undefined, { rejectWithValue }) => {
//     try {
//       const response = await api.timetableUpdated(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
//       return response.data
//     } catch (e) {
//       const error = toastError(e)
//       params?.onRejected && params.onRejected({ error })
//       return rejectWithValue(error)
//     } finally {
//       params?.onSettled && params.onSettled()
//     }
//   }
// )

export const distanceLearningTimetableAll = createAsyncThunk(
  TYPES.DISTANCE_LEARNING_TIMETABLE_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.DISTANCE_LEARNING_TIMETABLE_ALL}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.distanceLearningTimetableAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

// export const timetableGenerate = createAsyncThunk(
//   TYPES.TIMETABLE_GENERATE,
//   async (params: PayloadCreatorParams<`${typeof API.TIMETABLE_GENERATE}`, 'post'>, { rejectWithValue }) => {
//     try {
//       const response = await api.timetableGenerate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
//       return response.data
//     } catch (e) {
//       const error = toastError(e)
//       params?.onRejected && params.onRejected({ error })
//       return rejectWithValue(error)
//     } finally {
//       params?.onSettled && params.onSettled()
//     }
//   }
// )

export const distanceLearningTimetableGenerateUpdated = createAsyncThunk(
  TYPES.DISTANCE_LEARNING_TIMETABLE_GENERATE_UPDATED,
  async (
    params: PayloadCreatorParams<`${typeof API.DISTANCE_LEARNING_TIMETABLE_GENERATE_UPDATED}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.distanceLearningTimetableGenerateUpdated(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const distanceLearningTimetableUpdateStatus = createAsyncThunk(
  TYPES.DISTANCE_LEARNING_TIMETABLE_UPDATE_STATUS,
  async (
    params: PayloadCreatorParams<`${typeof API.DISTANCE_LEARNING_TIMETABLE_UPDATE_STATUS}`, 'put'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.distanceLearningTimetableUpdateStatus(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const distanceLearningTimetableHoursReport = createAsyncThunk(
  TYPES.DISTANCE_LEARNING_TIMETABLE_HOURS_REPORT,
  async (
    params: PayloadCreatorParams<`${typeof API.DISTANCE_LEARNING_TIMETABLE_HOURS_REPORT}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.distanceLearningTimetableHoursReport(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)
